import * as getters from './Getters'
import * as actions from './Actions'
import * as mutations from './Mutaions'

//Statelerimiz
const state = () => ({
    loading: false,
    companyId: null,
    company: {},
    companyTypes : [],
    companyStatus : {},
    companyPageInfo : {},
    addresses: [],
    addressStatus : {},    
    users: [],
    userStatus: {},
    companies: [],
    serviceFormStatus: {},
    serviceForms: [],
    serviceFormMovements: [],
    serviceFormMovePhotoStatus: {},
    serviceFormDetail: {},
    serviceFormPageInfo : {},

})

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Dealer/index.js